import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFaq, createFaq, fetchFaqDetail, modifyFaq, deleteFaq, changeStatus } from '../../api/faqApi';

export const getFaq = createAsyncThunk('faq/getFAQ', async (payload, { rejectWithValue }) => {
  try {
    const response = await fetchFaq(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addFaq = createAsyncThunk('faq/addFAQ', async (payload, { rejectWithValue }) => {
  try {
    const response = await createFaq(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getFaqDetail = createAsyncThunk('faq/getFAQ', async (faqId, { rejectWithValue }) => {
  try {
    const response = await fetchFaqDetail(faqId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
}); 

export const updateFaq = createAsyncThunk('faq/updateFAQ', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyFaq(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const destroyFaq = createAsyncThunk('faq/deleteFAQ', async (faqId, { rejectWithValue }) => {
  try {
    const response = await deleteFaq(faqId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('faq/changeDefaultStatus', async (faqId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(faqId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const faqSlice = createSlice({
  name: 'faq',
  initialState: {
    faqs: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFaq.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFaq.fulfilled, (state, action) => {
        state.isLoading = false;
        state.faqs = action.payload;
      })
      .addCase(getFaq.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default faqSlice.reducer;
